var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-home page",class:{
    wide: _vm.$responsive.wide
  }},[_c('div',{staticClass:"panes"},[_c('ViewNav'),(_vm.ready)?_c('div',{staticClass:"content vue-ui-disable-scroll"},[_c('TopBar'),_c('router-view',{staticClass:"router-view"})],1):_vm._e()],1),_c('ProgressScreen',{attrs:{"progress-id":"__plugins__"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }